import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=1dca2a8c&scoped=true&"
var script = {}
import style0 from "./IconLogo.vue?vue&type=style&index=0&id=1dca2a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca2a8c",
  null
  
)

export default component.exports